module.exports = __webpack_public_path__ + "static/media/image_13.0c5d51c2.png";